module.exports = __webpack_public_path__ + "static/media/covernote-default.3a16ea3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/covernote-default.svg
// module id = 419
// module chunks = 0